import "./ProjectEditDialog.scss";

import { useRef } from "react";
import { Box, IconButton, ModalDialog, Modal, OverflowContainer, PrimaryButton, SecondaryButton, Typography } from "@husqvarna/ui-core";
import { FormattedMessage, useIntl } from "react-intl";

import ProjectForm, { type ProjectFormRef } from "./ProjectForm";
import ProjectOverview from "../models/ProjectOverview";

export type ProjectEditDialogProps = {
  isOpen?: boolean;
  project?: ProjectOverview;
  onClosing?: (project: ProjectOverview | undefined) => void;
};

const ProjectEditDialog = ({
  isOpen,
  project,
  onClosing,
}: ProjectEditDialogProps) => {
  const intl = useIntl();
  const formRef = useRef<ProjectFormRef>(null);

  return (
    <Modal pageScrollLock closeable={false} active={isOpen} onClosing={() => onClosing?.(undefined)}>
      <ModalDialog br={6} className="tcsp-project__dialog">
        <IconButton className="tcsp-project__dialog-close" icon="close" onClick={() => onClosing?.(undefined)} />
        <Box ml={10} mr={2} mt={10} mb={6} container flexDirection="column" minHeightZero className="tcsp-project__dialog-body">
          <Typography variant="Heading4" mb={7}>
            <FormattedMessage id="project.editDialog.header" defaultMessage={"Project information"} />
          </Typography>
          <OverflowContainer className="tcsp-project__dialog-scroll" fadeOut="mask" offset={10} pt={3} pr={5} direction={"vertical"}>
            <ProjectForm
              ref={formRef}
              project={project}
              onFormSubmitted={(submittedProject) => onClosing?.(submittedProject)}
              onCancel={() => onClosing?.(undefined)}
            />
          </OverflowContainer>
          <Box className="tcsp-project__dialog-footer" justifyContent="flex-end" pt={6} mr={8} flexShrink={0}>
            <SecondaryButton
              text={intl.formatMessage({ id: "general.cancel", defaultMessage: "Cancel" })}
              onClick={() => onClosing?.(undefined)}
              mr={4}
            />
            <PrimaryButton
              text={project?.id ?
                intl.formatMessage({id: "project.editForm.update", defaultMessage: "Update project"})
                : intl.formatMessage({id: "project.editForm.save", defaultMessage: "Create project"})}
              onClick={() => formRef.current?.submit()}
            />
          </Box>
        </Box>
      </ModalDialog>
    </Modal>
  );
};

export default ProjectEditDialog;
